import { Delete } from "@mui/icons-material";
import { Button, CircularProgress, DialogActions, Stack } from "@mui/material";

type FormActionButtonProps = {
  isPending: boolean;
  isSubmitting?: boolean;
  onCancel: () => void;
  onSubmit: () => void;
  onDelete: () => void;
  mode: "edit" | "create";
  hasPermissionToDelete?: boolean;
  hasPermissionToSave?: boolean;
  disabled?: boolean;
};

export default function FormActionButton({
  isPending,
  onCancel,
  onSubmit,
  onDelete,
  mode,
  hasPermissionToDelete,
  hasPermissionToSave = true,
  disabled,
  isSubmitting
}: FormActionButtonProps) {
  return (
    <DialogActions sx={{ justifyContent: "flex-end", padding: "1.5rem" }}>
      <Stack
        direction='row'
        spacing={"0.62rem"}
        sx={{
          "& button": {
            textTransform: "none",
            borderRadius: "0.5rem"
          }
        }}
        aria-label='delete currently selected media'
      >
        {mode === "edit" && hasPermissionToDelete && (
          <Button onClick={onDelete} color='error' startIcon={<Delete />} disabled={isPending}>
            Delete
          </Button>
        )}
        <Button
          onClick={onCancel}
          variant='secondary-outlined'
          disabled={isPending}
          sx={{
            color: "grey.500",
            borderColor: "grey.500"
          }}
          aria-label='cancel and exit'
        >
          Cancel
        </Button>
        {hasPermissionToSave && (
          <Button
            disableElevation
            onClick={onSubmit}
            variant='contained'
            disabled={isPending || disabled}
            startIcon={isPending ? <CircularProgress size={16} /> : null}
            aria-label='submit form'
          >
            {isSubmitting ? (mode === "edit" ? "Updating..." : "Creating...") : mode === "edit" ? "Confirm and save" : "Create"}
          </Button>
        )}
      </Stack>
    </DialogActions>
  );
}
